

<template>
  <nav class="sidebar sidebar-offcanvas" id="sidebar">
    <ul class="nav">
      <li class="nav-item" @mouseenter="handleItemMouseEnter($event, 'Inicio')" @mouseleave="scheduleFlyoutClose">
        <a class="nav-link" href="/" :class="{ 'is-active-module': isModuleActive('home') }">
          <i class="fa-solid fa-house menu-icon"></i>
          <span class="menu-title notranslate">Inicio</span>
        </a>
      </li>
      <li class="nav-item" @mouseenter="handleItemMouseEnter($event, 'Dashboard')" @mouseleave="scheduleFlyoutClose">
        <a class="nav-link" href="/dashboard" :class="{ 'is-active-module': isModuleActive('dashboard') }">
          <i class="fa-solid fa-chart-line menu-icon"></i>
          <span class="menu-title notranslate">Dashboard</span>
        </a>
      </li>
      <li
        v-if="Admin || Coordinacion || Asesor"
        class="nav-item"
        @mouseenter="handleOriginMouseEnter"
        @mouseleave="scheduleFlyoutClose"
      >
        <a
          class="nav-link"
          href="#"
          aria-controls="ui-basic-2"
          :aria-expanded="String(originOpen)"
          :class="{
            'is-active-module': isModuleActive('originacion'),
            'is-origin-open': originOpen
          }"
          @click.prevent="toggleOriginMenu"
        >
          <i class="fa-solid fa-address-book menu-icon"></i>
          <span class="menu-title">Clientes y Solicitudes</span>
          <i class="menu-arrow"></i>
        </a>
        <div class="collapse" id="ui-basic-2" :class="{ show: originOpen }">
          <ul class="nav flex-column sub-menu">
            <li class="nav-item">
              <router-link class="nav-link" to="/mostrar-solicitantes">Clientes</router-link>
            </li>

            <li v-if="!Consultor" class="nav-item">
              <router-link class="nav-link" to="/mostrar-solicitudes">Solicitudes</router-link>
            </li>
            <li v-if="Admin || Finanzas" class="nav-item">
              <router-link class="nav-link" to="/mostrar-solicitudes-aceptadas">Otorgar</router-link>
            </li>
          </ul>
        </div>
      </li>
      <!-- <li v-if="Admin || Coordinacion || Consultor || Asesor || coordinadorSucursal || Finanzas" class="nav-item">
        <a class="nav-link" data-bs-toggle="collapse" href="#ui-basic" aria-expanded="false" aria-controls="ui-basic">
          <i class="fa-solid fa-pencil menu-icon"></i>
          <span class="menu-title">Solicitudes</span>
          <i class="menu-arrow"></i>
        </a>
        <div class="collapse" id="ui-basic">
          <ul class="nav flex-column sub-menu">
            
          </ul>
        </div>
      </li> -->
      <li class="nav-item">
        <router-link class="nav-link" to="/cartera" :class="{ 'is-active-module': isModuleActive('cartera') }" @mouseenter="handleItemMouseEnter($event, 'Cartera')" @mouseleave="scheduleFlyoutClose">
          <i class="fa-solid fa-wallet menu-icon"></i>
          <span class="menu-title">Cartera</span>
        </router-link>
      </li>
      <li
        v-if="cobranzaOptions.length"
        class="nav-item"
        @mouseenter="handleCobranzaMouseEnter"
        @mouseleave="scheduleFlyoutClose"
      >
        <a
          class="nav-link"
          href="#"
          aria-controls="ui-cobranza"
          :aria-expanded="String(cobranzaOpen)"
          :class="{
            'is-active-module': isModuleActive('cobranza'),
            'is-origin-open': cobranzaOpen
          }"
          @click.prevent="toggleCobranzaMenu"
        >
          <i class="fa-solid fa-hand-holding-dollar menu-icon"></i>
          <span class="menu-title">Cobranza</span>
          <i class="menu-arrow"></i>
        </a>
        <div class="collapse" id="ui-cobranza" :class="{ show: cobranzaOpen }">
          <ul class="nav flex-column sub-menu">
            <li
              v-for="option in cobranzaOptions"
              :key="option.to"
              class="nav-item"
            >
              <router-link class="nav-link" :to="option.to">{{ option.label }}</router-link>
            </li>
          </ul>
        </div>
      </li>
      <!-- Proceso Legal oculto temporalmente.
      <li class="nav-item">
        <router-link class="nav-link" to="/proceso-legal" :class="{ 'is-active-module': isModuleActive('proceso-legal') }" @mouseenter="handleItemMouseEnter($event, 'Proceso Legal')" @mouseleave="scheduleFlyoutClose">
          <i class="fa-solid fa-gavel menu-icon "></i>
          <span class="menu-title">Proceso Legal</span>
        </router-link>
      </li>
      -->
      <li v-if="Admin" class="nav-item" >
        <router-link class="nav-link" to="/whatsapp" style="color: green" :class="{ 'is-active-module': isModuleActive('whatsapp') }" @mouseenter="handleItemMouseEnter($event, 'Whatsapp')" @mouseleave="scheduleFlyoutClose">
          <i class="fa-brands fa-whatsapp menu-icon" style="color: green"></i>
          <span class="menu-title">Whatsapp</span>
        </router-link>
      </li>
      <li
        v-if="configurarOptions.length"
        class="nav-item"
        @mouseenter="handleConfigurarMouseEnter"
        @mouseleave="scheduleFlyoutClose"
      >
        <a
          class="nav-link"
          href="#"
          aria-controls="ui-configurar"
          :aria-expanded="String(configurarOpen)"
          :class="{
            'is-active-module': isModuleActive('configurar'),
            'is-origin-open': configurarOpen
          }"
          @click.prevent="toggleConfigurarMenu"
        >
          <i class="fa-solid fa-gear menu-icon"></i>
          <span class="menu-title">Configurar</span>
          <i class="menu-arrow"></i>
        </a>
        <div class="collapse" id="ui-configurar" :class="{ show: configurarOpen }">
          <ul class="nav flex-column sub-menu">
            <li
              v-for="option in configurarOptions"
              :key="option.to"
              class="nav-item"
            >
              <router-link class="nav-link" :to="option.to">{{ option.label }}</router-link>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div
      v-if="flyout.visible && isCollapsed"
      class="sidebar-flyout"
      :style="flyout.style"
      @mouseenter="cancelFlyoutClose"
      @mouseleave="scheduleFlyoutClose"
    >
      <template v-if="flyout.type === 'originacion'">
        <router-link
          v-for="option in originOptions"
          :key="option.to"
          class="sidebar-flyout-option"
          :to="option.to"
        >
          {{ option.label }}
        </router-link>
      </template>
      <template v-else-if="flyout.type === 'cobranza'">
        <router-link
          v-for="option in cobranzaOptions"
          :key="option.to"
          class="sidebar-flyout-option"
          :to="option.to"
        >
          {{ option.label }}
        </router-link>
      </template>
      <template v-else-if="flyout.type === 'configurar'">
        <router-link
          v-for="option in configurarOptions"
          :key="option.to"
          class="sidebar-flyout-option"
          :to="option.to"
        >
          {{ option.label }}
        </router-link>
      </template>
      <template v-else>
        <span>{{ flyout.label }}</span>
      </template>
    </div>
  </nav>
</template>

<script>
import Security from './security';

export default {
  name: 'Navbar-Lateral',
  data() {
    return {
      roles: ['Coordinacion', 'Admin', 'Finanzas', 'Asesor', 'Coordinador Sucursal', 'Consultor', 'oficinaGeneral'],
      Finanzas: false,
      coordinadorSucursal: false,
      Admin: false,
      Coordinacion: false,
      Asesor: false,
      Consultor: false,
      oficinaGeneral: false,
      userRoles: [],
      originOpen: false,
      cobranzaOpen: false,
      configurarOpen: false,
      flyout: {
        visible: false,
        label: '',
        type: 'label',
        style: {},
      },
      flyoutCloseTimeout: null,
      sidebarIconOnly: false,
      bodyObserver: null,
    };
  },
  computed: {
    isCollapsed() {
      return this.sidebarIconOnly;
    },
    originOptions() {
      const options = [
        { label: 'Clientes', to: '/mostrar-solicitantes' },
      ];
      if (!this.Consultor) {
        options.push({ label: 'Solicitudes', to: '/mostrar-solicitudes' });
      }
      if (this.Admin || this.Finanzas) {
        options.push({ label: 'Otorgar', to: '/mostrar-solicitudes-aceptadas' });
      }
      return options;
    },
    cobranzaOptions() {
      const options = [];

      if (this.Admin || this.Finanzas || this.Consultor) {
        options.push({ label: 'Pagos', to: '/pagos' });
        options.push({ label: 'Seguimiento', to: '/bitacora' });
        options.push({ label: 'Proyeccion', to: '/proyeccion' });
      }

      options.push({ label: 'Recordatorios', to: '/recordatorios' });

      return options;
    },
    configurarOptions() {
      if (!this.Admin && !this.Finanzas) return [];

      const options = [];

      if (this.Admin || this.Finanzas) {
        options.push({ label: 'Productos', to: '/productos' });
      }

      if (this.Admin) {
        options.push(
          { label: 'Gestion de Usuarios', to: '/axccAdminSettings' },
          { label: 'Registro de Actividades', to: '/registro-actividades' },
          { label: 'Bancos', to: '/bancos' }
        );
      }

      return options;
    },
  },
  mounted() {
    // Obtener roles del usuario y configurar dinámicamente las variables de acceso
    this.userRoles = Security.getUserRoles();
    this.roles.forEach((role) => {
      if (this.userRoles[0]?.some((userRole) => userRole.includes(role))) {
        this[role] = true;
      }
    });
    this.syncOriginByRoute();
    this.syncCobranzaByRoute();
    this.syncConfigurarByRoute();
    this.syncSidebarState();
    this.bodyObserver = new MutationObserver(() => {
      this.syncSidebarState();
    });
    this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  },
  watch: {
    $route() {
      this.syncOriginByRoute();
      this.syncCobranzaByRoute();
      this.syncConfigurarByRoute();
      this.flyout.visible = false;
    },
  },
  beforeUnmount() {
    this.clearFlyoutTimeout();
    if (this.bodyObserver) {
      this.bodyObserver.disconnect();
      this.bodyObserver = null;
    }
  },
  methods: {
    syncSidebarState() {
      this.sidebarIconOnly = document.body.classList.contains('sidebar-icon-only');
    },
    isModuleActive(moduleName) {
      const currentPath = this.$route?.path || '/';
      const map = {
        home: ['/', '/home'],
        dashboard: ['/dashboard'],
        originacion: ['/solicitud', '/mostrar-solicitantes', '/mostrar-solicitudes', '/mostrar-solicitudes-aceptadas'],
        cartera: ['/cartera'],
        cobranza: ['/pagos', '/bitacora', '/proyeccion', '/recordatorios'],
        configurar: ['/axccAdminSettings', '/registro-actividades', '/bancos', '/productos', '/producto/nuevo'],
        recordatorios: ['/recordatorios'],
        pagos: ['/pagos'],
        bitacora: ['/bitacora'],
        proyeccion: ['/proyeccion'],
        'proceso-legal': ['/proceso-legal'],
        whatsapp: ['/whatsapp'],
        usuarios: ['/axccAdminSettings'],
        'registro-actividades': ['/registro-actividades'],
        bancos: ['/bancos'],
      };

      const modulePaths = map[moduleName] || [];
      if (moduleName === 'home') {
        return currentPath === '/';
      }
      return modulePaths.some((path) => currentPath.startsWith(path));
    },
    syncOriginByRoute() {
      this.originOpen = this.isModuleActive('originacion');
    },
    syncCobranzaByRoute() {
      this.cobranzaOpen = this.isModuleActive('cobranza');
    },
    syncConfigurarByRoute() {
      this.configurarOpen = this.isModuleActive('configurar');
    },
    toggleOriginMenu() {
      this.originOpen = !this.originOpen;
      if (this.originOpen) {
        this.cobranzaOpen = false;
        this.configurarOpen = false;
      }
    },
    toggleCobranzaMenu() {
      this.cobranzaOpen = !this.cobranzaOpen;
      if (this.cobranzaOpen) {
        this.originOpen = false;
        this.configurarOpen = false;
      }
    },
    toggleConfigurarMenu() {
      this.configurarOpen = !this.configurarOpen;
      if (this.configurarOpen) {
        this.originOpen = false;
        this.cobranzaOpen = false;
      }
    },
    handleItemMouseEnter(event, label) {
      if (!this.isCollapsed) return;
      this.cancelFlyoutClose();
      this.setFlyout(event.currentTarget, label, 'label');
    },
    handleOriginMouseEnter(event) {
      if (!this.isCollapsed) return;
      this.cancelFlyoutClose();
      this.setFlyout(event.currentTarget, 'Clientes y Solicitudes', 'originacion');
    },
    handleCobranzaMouseEnter(event) {
      if (!this.isCollapsed) return;
      this.cancelFlyoutClose();
      this.setFlyout(event.currentTarget, 'Cobranza', 'cobranza');
    },
    handleConfigurarMouseEnter(event) {
      if (!this.isCollapsed) return;
      this.cancelFlyoutClose();
      this.setFlyout(event.currentTarget, 'Configurar', 'configurar');
    },
    setFlyout(target, label, type) {
      const rect = target.getBoundingClientRect();
      this.flyout.style = {
        top: `${rect.top}px`,
        left: `${rect.right + 8}px`,
      };
      this.flyout.label = label;
      this.flyout.type = type;
      this.flyout.visible = true;
    },
    scheduleFlyoutClose() {
      this.clearFlyoutTimeout();
      this.flyoutCloseTimeout = setTimeout(() => {
        this.flyout.visible = false;
      }, 120);
    },
    cancelFlyoutClose() {
      this.clearFlyoutTimeout();
    },
    clearFlyoutTimeout() {
      if (this.flyoutCloseTimeout) {
        clearTimeout(this.flyoutCloseTimeout);
        this.flyoutCloseTimeout = null;
      }
    },
  },
};
</script>

<style scoped>
.fa-solid {
  /* Define estilos adicionales si es necesario */
  color: white;
}
.sidebar{
    padding: 5px;
}
.sidebar .nav .nav-item .nav-link {
  /* color: #56595a; */
}
.nav{
  background-color: rgb(30, 30, 30);
  height: auto !important;
  border-radius: 10px;
  
}

.nav-item:hover{
  /* background-color: rgb(50, 50, 50) !important; */
  border-radius: 10px !important;
}
.nav-link:hover{
  /* background-color: rgb(50, 50, 50) !important; */
  border-radius: 5px !important;
}

.nav-link.is-active-module .menu-icon {
  color: #F9B233 !important;
}

.nav-link.is-origin-open {
  background-color: #222 !important;
  border-radius: 5px !important;
}

.sidebar-flyout {
  position: fixed;
  z-index: 1200;
  min-width: 190px;
  background-color: #222;
  color: #fff;
  border-radius: 8px;
  padding: 8px 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sidebar-flyout-option {
  color: #fff;
  text-decoration: none;
  padding: 7px 8px;
  border-radius: 6px;
}

.sidebar-flyout-option:hover {
  background-color: #343434;
}
</style>
